import { UserPermission } from '@globaleris/ui.library'
import { Button } from '@material-ui/core'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router'
import ButtonWithPermissions from '../../../../components/buttonWithPermissions/buttonWithPermissions'
import { hasPermission } from '../../../../helpers/permissionsHelper'
import { Resources } from '../../../../model/RBAC/constants'

interface ActionHeaderButtonsProps {
  quoteIsDraft: boolean
  leadTypeIsCustom: boolean
  onPublishClick: () => void
  onSaveWithOutPublishClick: () => void
  onRejectClick: () => void
  onEvaluateAgainClick: () => void
  onCancelClick: () => void
}

export const ActionHeaderButtons: React.FC<ActionHeaderButtonsProps> = ({
  quoteIsDraft,
  leadTypeIsCustom,
  onPublishClick,
  onSaveWithOutPublishClick,
  onRejectClick,
  onEvaluateAgainClick,
  onCancelClick
}) => {
  const [t] = useTranslation(['globalerisLibrary', 'quotes', 'enums'])
  const history = useHistory()

  // #region Handlers Starts
  // #endregion Handlers Ends

  // #region Functions Starts
  // #endregion Functions Ends

  // #region Form Definition Starts
  // #endregion Form Definition Ends

  // #region DataTable Config Starts
  // #endregion DataTable Config Ends

  // #region Hooks Starts
  // #endregion Hooks Ends

  return (
    <>
      <Button variant="text" color="primary" size="small" onClick={onCancelClick}>
        {t('quotes:actions.back')}
      </Button>
      <ButtonWithPermissions
        variant="text"
        color="primary"
        size="small"
        hasPermission={quoteIsDraft && hasPermission(Resources.Leads, [UserPermission.EDIT])}
        onClick={onEvaluateAgainClick}
      >
        {t('quotes:actions.evaluateAgain')}
      </ButtonWithPermissions>
      <ButtonWithPermissions
        variant="text"
        color="primary"
        size="small"
        hasPermission={
          quoteIsDraft && leadTypeIsCustom && hasPermission(Resources.Leads, [UserPermission.EDIT])
        }
        onClick={onRejectClick}
      >
        {t('quotes:actions.reject')}
      </ButtonWithPermissions>
      <ButtonWithPermissions
        variant="text"
        color="primary"
        size="small"
        hasPermission={quoteIsDraft && hasPermission(Resources.Leads, [UserPermission.EDIT])}
        onClick={onSaveWithOutPublishClick}
      >
        {t('quotes:actions.saveWithOutPublish')}
      </ButtonWithPermissions>
      <ButtonWithPermissions
        variant="contained"
        color="primary"
        size="small"
        hasPermission={quoteIsDraft && hasPermission(Resources.Leads, [UserPermission.EDIT])}
        onClick={onPublishClick}
      >
        {t('quotes:actions.publish')}
      </ButtonWithPermissions>
    </>
  )
}
